export function cut(arr) {
  return arr.filter(x => x);
}

export function ensureHttps(link) {
  let [protocol, url] = link.split(/:\/\//);
  url = url || protocol;
  protocol = 'https';
  return [protocol, url].join('://');
}
